import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() =>
      api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false))
    );
  }, []);
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
